(() => {
  const prepareDescriptions = () => {
    document.querySelectorAll(".rival-collection-about:not([data-prepared])").forEach((details) => {
      details.dataset.prepared = "true";
      const body = details.querySelector(".rival-collection-description");
      if (!body) return;
      const button = details.querySelector("button");
      if (!button) return;
      details.dataset.expanded = "false";
      if (body.scrollHeight <= body.clientHeight + 1) {
        delete details.dataset.expanded;
        return;
      }
      button.hidden = false;
      button.addEventListener("click", () => {
        const expanded = details.dataset.expanded !== "true";
        details.dataset.expanded = String(expanded);
        button.setAttribute("aria-expanded", String(expanded));
      });
    });
  };
  const sync = () => {
    prepareDescriptions();
    const settings = document.querySelector("[data-rival-collection-settings]");
    if (!settings) return;
    const hidden = (settings.dataset.hiddenNativeFilters || "")
      .split(",")
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);
    document
      .querySelectorAll(".facet-accordion-details[data-filter]")
      .forEach((group) => {
        const inputs = [...group.querySelectorAll("input")];
        const name =
          inputs.find((input) => input.name.startsWith("filter."))?.name || "";
        const key =
          name === "filter.p.vendor"
            ? "showBrand"
            : name === "filter.p.product_type"
              ? "showType"
              : name === "filter.v.availability"
                ? "showAvailability"
                : name.startsWith("filter.v.price.")
                  ? "showPrice"
                  : "";
        const title = group
          .querySelector("summary .h6")
          ?.firstChild?.textContent?.trim()
          .toLowerCase();
        const active = inputs.some((input) =>
          input.type === "checkbox"
            ? input.checked
            : input.type === "number" && input.value !== "",
        );
        group.hidden =
          !active &&
          (settings.dataset[key] === "false" || hidden.includes(title));
      });
    const sidebar = document.querySelector("#FacetFiltersContainer");
    const groups = [
      ...(sidebar?.querySelectorAll(".facet-accordion-details[data-filter]") ||
        []),
    ];
    if (sidebar && groups.length) {
      const empty = groups.every((group) => group.hidden);
      sidebar.dataset.rivalNativeEmpty = String(empty);
      document.querySelectorAll(".facet-drawer-wrapper").forEach((wrapper) => {
        wrapper.dataset.rivalNativeEmpty = String(empty);
      });
    }
  };
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };
  sync();
  const main = document.querySelector("main");
  if (main)
    new MutationObserver(schedule).observe(main, {
      childList: true,
      subtree: true,
    });
  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("change", schedule);
})();
